import { Modal } from '@components/Modal';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteCreationModalProps {
  isOpen: boolean;
  creationName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ConfirmDeleteCreationModal = memo(
  ({
    isOpen,
    creationName,
    onConfirm,
    onCancel,
    isLoading = false,
  }: ConfirmDeleteCreationModalProps) => {
    const { t } = useTranslation();
    return (
      <Modal
        title={t('creations.deleteCreation')}
        onClose={onCancel}
        isOpen={isOpen}
        maxWidth="max-w-sm"
        showCloseButton={!isLoading}>
        <>
          <p className="text-white/80 mb-2 break-words">
            {t('creations.deleteConfirmation', { name: creationName })}
          </p>
          <p className="text-white/80 mb-6">{t('creations.deleteWarning')}</p>

          {/* Footer - Buttons */}
          <div className="flex gap-3 justify-end border-t border-white/10 pt-6">
            <button
              onClick={onCancel}
              disabled={isLoading}
              className="px-4 h-[44px] bg-[rgba(128,128,128,0.3)] hover:bg-[rgba(128,128,128,0.4)] text-white rounded-[16px] font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center">
              {t('common.cancel')}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-4 h-[44px] bg-red-600 hover:bg-red-700 text-white rounded-[16px] font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 justify-center">
              {isLoading && (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              )}
              {t('common.delete')}
            </button>
          </div>
        </>
      </Modal>
    );
  },
);

ConfirmDeleteCreationModal.displayName = 'ConfirmDeleteCreationModal';
